"use client";

import React, { FC, useEffect, useState } from "react";
import SearchModal from "./SearchModal";
import MobileSearchSheet from "./MobileSearchSheet";

/**
 * Search icon button for the topbar. On mobile (<=1024 px) it opens the
 * slide-down MobileSearchSheet that the homepage hero also uses — same UX
 * end-to-end. On desktop it keeps the existing full-screen SearchModal,
 * which the user has flagged as canonical and shouldn't change.
 */
const SearchTrigger: FC<{ className?: string }> = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 1024);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <>
      <button
        type="button"
        aria-label="Open search"
        onClick={() => setOpen(true)}
        className={`w-10 h-10 rounded-full flex items-center justify-center text-white/90 hover:text-white hover:bg-white/10 focus:outline-none transition-colors ${className}`}
      >
        <svg
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="M21 21l-4.3-4.3" />
        </svg>
      </button>
      {open &&
        (isMobile ? (
          <MobileSearchSheet onClose={() => setOpen(false)} />
        ) : (
          <SearchModal open={open} onClose={() => setOpen(false)} />
        ))}
    </>
  );
};

export default SearchTrigger;
